import { render, staticRenderFns } from "./CardMediaPreview.vue?vue&type=template&id=234b0210&scoped=true"
import script from "./CardMediaPreview.vue?vue&type=script&lang=js"
export * from "./CardMediaPreview.vue?vue&type=script&lang=js"
import style0 from "./CardMediaPreview.vue?vue&type=style&index=0&id=234b0210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b0210",
  null
  
)

export default component.exports